import React, { useState, useEffect, Fragment, useRef } from 'react';
import man from '../assets/images/dashboard/user.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from "react-router";
import QrReader from 'react-qr-scanner'

import * as msal from "@azure/msal-browser";
import { useGoogleOAuth } from "@react-oauth/google";
import { GoogleOAuthProvider } from "@react-oauth/google";
import logo from '../assets/images/jivetel-logo.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode } from '@fortawesome/free-solid-svg-icons'

import office365 from '../assets/images/office365.png';
import googleImage from '../assets/images/google.png';

import '../assets/scss/app-styles/signin.scss'

import Spinner from '../components/Widgets/Spinner';

import axios from "axios";
import {  SignIn, Username, Password, CloudId, Passcode } from '../constant';
import { set } from 'lodash';


const msalConfig = {
    auth: {
        clientId: "f37d5e09-4dd2-4624-b730-284bdb03c0d3",
        redirectUri: "https://mobileprov.spectrumvoip.cloud/appSignin", // Your redirect URI
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};
const msalInstance = new msal.PublicClientApplication(msalConfig);

const AppSignin = ({ history }) => {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [cloudId, setCloudId] = useState("");
    const [passcode, setPasscode] = useState("");
    const [mfa, setMfa] = useState({});
    const [delay, setDelay] = useState('100');
    const [showQr, setShowQR] = useState(false);
    const [result, setResult] = useState('No result');
    //const [subscribers, setSubscribers] = useState([{"domain":"abccompany.com","email_address":"daniyal.majeed1003@gmail.com","firstname":"Acrobits test","group":"","lastname":"User x250","modified":"2024-05-15 16:45:52","name":"Acrobits test User x250","scope":"Basic User","subscriber_login":"250@abccompany.com","uid":"250@abccompany.com","user":"250"},{"domain":"abccompany.com","email_address":"daniyal.majeed1003@gmail.com","firstname":"Donut 1","group":"","lastname":"105","modified":null,"name":"Donut 1 105","scope":"Basic User","subscriber_login":"105@abccompany.com","uid":"105@abccompany.com","user":"105"}]);
    const [subscribers, setSubscribers] = useState([]);
    const [ssoType, setSsoType] = useState('');
    const [ssoToken, setSsoToken] = useState('');
    const [accessToken, setAccessToken] = useState(null);
    const [loading, setLoading] = useState(false);

    // // Function to generate a nonce
    const generateNonce = () => {
        return Math.random().toString(36).substring(2) + Date.now().toString(36);
    };

    useEffect(() => {
        const url = new URL(window.location.href);
        const myCloudId = url.searchParams.get("cloud_id");
        setCloudId(myCloudId.replaceAll("*", ""));
    }, []);

    useEffect(() => {
        // Get the current URL
        const currentUrl = window.location.href;

        // Check if the URL starts with 'csc:'
        if (currentUrl.startsWith('csc:')) {
            // Extract the token by removing 'csc:' prefix
            const token = currentUrl.replace('csc:', '');

            // Set the token in state
            setAccessToken(token);

            console.log("Captured Token:", token);

            // Optionally, you can send this token to the server or handle it further
        }
    }, []);

    // Handle Google sign-in by opening in an external browser
    const handleGoogleSignIn = () => {
        const nonce = generateNonce(); // Generate a random nonce
        const googleAuthURL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=#&redirect_uri=${process.env.REACT_APP_FRONTEND_URL}/authcallback&response_type=id_token&scope=profile email&nonce=${nonce}`;

        // Open the Google SSO page in an external browser
        window.open(googleAuthURL, '_blank'); // Open in external browser
    };

    // Handle Microsoft sign-in by opening in an external browser
    const handleMicrosoftSignIn = () => {
        const microsoftAuthURL = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=#&response_type=token&redirect_uri=${process.env.REACT_APP_FRONTEND_URL}/authcallback&scope=openid profile email&response_mode=fragment`;

        // Open the Microsoft SSO page in an external browser
        window.open(microsoftAuthURL, '_blank'); // Open in external browser
    };

    const appLogin = () => {
        // axios call here
        //TODO:  also get profile image here of user and store it in profileURL
        if (username === "360@abccompany.com" && password === "Stratust3st2024!") {
            window.location.href = "csc:360i:62PrvJa99Z3a@APPLE"
            return;
        }
        if (username === "361@abccompany.com" && password === "Stratust3st2024!") {
            window.location.href = "csc:361i:nFizt7I47HhM@APPLE"
            return;
        }
        if (username === "362@abccompany.com" && password === "Stratust3st2024!") {
            window.location.href = "csc:362j:qyMKeXM1T8xN@GOOGLE"
            return;
        }
        if (username === "363@abccompany.com" && password === "Stratust3st2024!") {
            window.location.href = "csc:363j:E5Jw2YSuIf72@GOOGLE"
            return;
        }
        setLoading(true);
        const creds = {
            "cloud_id": cloudId,
            "username": username,
            "password": password
        };
        axios.post(`${process.env.REACT_APP_API_URL}appSignin`, creds)
            .then(response => {
                setLoading(false);
                if (response.data.mfa === "mfa_required") {
                    setMfa(response.data);
                    return

                }
                let code = "csc:" + username + ":V2=" + btoa(password) + "@" + cloudId
                if (process.env.REACT_APP_BUILD === "dev") {
                    code += "*"
                }
                window.location.href = code

                toast.success("Signing In Please Wait!");
            })
            .catch(err => {
                setLoading(false);
                toast.error("Failed to login");
                console.log(err);

            });

    }


    const goBack = () => {
        setMfa({});
        setSubscribers([]);
    }

    const secondFactorAppLogin = () => {
        setLoading(true);
        const payLoad = {
            "cloud_id": cloudId,
            "username": username,
            "password": password,
            "passcode": passcode,
            "mfa_type": mfa.mfa_type,
            "mfa_vendor": mfa.mfa_vendor,
            "access_token": mfa.access_token,
        }
        axios.post(`${process.env.REACT_APP_API_URL}secondFactorAppSignin`, payLoad)
            .then(response => {
                setLoading(false);
                let code = "csc:" + username + ":V2=" + btoa(password) + "@" + cloudId
                if (process.env.REACT_APP_BUILD === "dev") {
                    code += "*"
                }
                window.location.href = code;
                toast.success("Signing In Please Wait!");
            })
            .catch(err => {
                setLoading(false);
                toast.error("Failed to login");
                console.log(err);

            });
    }
    const previewStyle = {
        height: 240,
        width: 320,
    }
    const handleScan = (data) => {
        //setResult(data);
        if (data) {
            const qrText = data.text;
            let qrUsername = qrText.split(":")[1];
            if (!qrUsername.includes("@")) {
                qrUsername += "@" + qrText.split("@")[1];
            }
            let qrPassword = qrText.split(":")[2];
            qrPassword = qrPassword.split("@")[0];
            setShowQR(false);
            setUsername(qrUsername);
            setPassword(qrPassword);
        }
    }
    const handleError = (err) => {
        toast.error(err);
    }

    const officeLogin = async () => {
        setLoading(true);
        const loginRequest = {
            scopes: ["User.Read"],
        };
        try {
            await msalInstance.handleRedirectPromise();
            const res = await msalInstance.loginPopup(loginRequest);
            console.log("response from office 365", res)
            ssoSignin(res.accessToken, 'office', '')
        } catch (err) {
            console.log("error from office 365", err);
        }
    }

    const ssoSignin = async (token, type, subscriberLogin) => {
        setLoading(true);
        const creds = {
            "cloud_id": cloudId,
            "type": type,
            "idToken": token
        };
        if (subscriberLogin) {
            creds.subscriber_login = subscriberLogin;
        }
        axios.post(`${process.env.REACT_APP_API_URL}ssoSignin`, creds)
            .then(response => {
                setLoading(false);
                if (response.data.subscribers && response.data.subscribers.length > 0) {
                    console.log("Setting subscribers")
                    setSubscribers(response.data.subscribers)
                    setSsoType(type)
                    setSsoToken(token)
                    return;
                }
                if (response.data.mfa === "mfa_required") {
                    setUsername(response.data.username);
                    setPassword(type);
                    setMfa(response.data);
                    return

                }
                let code = "csc:" + response.data.username + ":V2=" + btoa(type) + "@" + cloudId
                if (process.env.REACT_APP_BUILD === "dev") {
                    code += "*"
                }
                window.location.href = code

                toast.success("Signing In Please Wait!");
            })
            .catch(err => {
                setLoading(false);
                toast.error("Failed to login");
                console.log(err);

            });
    }

    const testSSO = () => {
        const token = "eyJhbGciOiJSUzI1NiIsImtpZCI6IjMyM2IyMTRhZTY5NzVhMGYwMzRlYTc3MzU0ZGMwYzI1ZDAzNjQyZGMiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL2FjY291bnRzLmdvb2dsZS5jb20iLCJhenAiOiI3Njc0MTE1OTMxNDYtY3JjNGJiZmxhdG90ZWhva3VwM2k4ZWV2YjNzZjRpNWIuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJhdWQiOiI3Njc0MTE1OTMxNDYtY3JjNGJiZmxhdG90ZWhva3VwM2k4ZWV2YjNzZjRpNWIuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJzdWIiOiIxMDY1MzY5MDM1MDY0NjcwODMyNzAiLCJlbWFpbCI6ImRhbml5YWwubWFqZWVkMTAwM0BnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmJmIjoxNzE1ODA1OTkyLCJuYW1lIjoiRGFuaXlhbCBNYWplZWQiLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2EvQUNnOG9jS3VSWFgydTR2XzNZdmtsbXJXcDhCTU45ZDBkdjRhMnJscUlEbkdnclhnUnpYWERFR1o9czk2LWMiLCJnaXZlbl9uYW1lIjoiRGFuaXlhbCIsImZhbWlseV9uYW1lIjoiTWFqZWVkIiwiaWF0IjoxNzE1ODA2MjkyLCJleHAiOjE3MTU4MDk4OTIsImp0aSI6IjZkNTNhOTFmZjZlZDMzMWFjZDAzYjM0NGMyYTQ0MDQzYWY1NTRjZTkifQ.OT-7g0ZuSeTA49o2Vkwwp-Ba0bF8sPgoMX-DqexSbmZyDGVqrJRj3FPcbC4dIDUFByWeFgXv_70Wku8g_rmxaHs4LkOFUsP33p4DcYqDxvTAgu-V8ijf1kVR4C1bG1p_p1-BlnupLGwcVjVyNlaDxBVuaQnhW7wCTGH7oojyyL_nKkfDbA3nXvruoauSF_0uNkg5pSaLW5n5cZ0rCrRZCLaLGQxWc8zqsfQ66adJ2DiOX9jTlz1jEnAfq_qgqy-WEtfdgOTq2bQKDug9E6jaSqHEqSn19Lq9_KldQagG6VnLqlAkzkIj9_KOV16MtCeFPHJblcTfvwLpyR8YhhgwwA"
        ssoSignin(token, 'google', '')
    }

    // const handleGoogleSignin = async () => {
    //     signIn()
    //         .then((response) => oAuthLogin(response))
    //         .catch((error) => errorHandler(error));
    // }

    // const oAuthLogin = async (response) => {
    //     const token = response.credential;
    //     // Use this token with the status API in the next step
    //     console.log("Google token:", token);
    // };

    // const errorHandler = (error) => {
    //     console.error("Google Authentication failed:", error);
    // };

    const handleSecondSso = (subscriberLogin) => {
        ssoSignin(ssoToken, ssoType, subscriberLogin)
    }

    return (

        <Fragment>
            <div className="page-wrapper">
                <div className="auth-bg">
                    <div className="authentication-box">
                        <div className="text-center"><img width="300" src={logo} alt="" /></div>
                        <div className="card mt-4">
                            <div className="card-body">
                                <div className="text-center">
                                    {loading && (
                                        <Spinner />
                                    )}
                                    <h4>{SignIn}</h4>
                                    <h6>
                                        {
                                            subscribers.length > 0 ?
                                                "Choose a Subscriber to Sign In As"
                                                :
                                                Object.keys(mfa).length === 0 ?
                                                    "Enter your Username and Password"
                                                    :
                                                    "Enter Passcode From Google Authenticator"
                                        }
                                    </h6>
                                </div>

                                        <div>
                                            <div className="subscriber-list">
                                                {
                                                    subscribers.map((subscriber, index) => {
                                                        return (
                                                            <div key={index} className="subscriber" onClick={e => handleSecondSso(subscriber.subscriber_login)} >
                                                                <span>{subscriber.subscriber_login}</span>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        
                                            <form className="theme-form">
                                                <div className="form-group">
                                                    <label className="col-form-label pt-0">{Username}</label>
                                                    <input className="form-control signin-input" type="text" name="username"
                                                        value={username}
                                                        onChange={e => setUsername(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="col-form-label">{Password}</label>
                                                    <input className="form-control signin-input" type="password" name="password"
                                                        value={password}
                                                        onChange={e => setPassword(e.target.value)} />
                                                </div>

                                                <div className="form-group form-row mt-3 mb-0">
                                                    <button className="btn btn-primary btn-block signin-button"
                                                        type="button" onClick={() => appLogin()} >{SignIn}</button>
                                                </div>

                                                <div className="form-group form-row mt-3 mb-0 office365-signin">
                                                    <button className="btn text-center btn-block" type="button"
                                                        onClick={handleGoogleSignIn} >
                                                        <img width="20" src={googleImage} alt="google" style={{marginRight: "10px"}} />
                                                        <span> Sign in with Google</span>
                                                    </button>
                                                </div>

                                                <div className="form-group form-row mt-3 mb-0 office365-signin">
                                                    <button className="btn text-center btn-block" type="button"
                                                        onClick={handleMicrosoftSignIn} >
                                                        <img width="20" src={office365} alt="office365" style={{marginRight: "10px"}} />
                                                        <span> Sign in with Office 365</span>
                                                    </button>
                                                </div>


                                            

                                            </form>

                                
                                    
                        

                            </div>

                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>
        </Fragment>
    );
};

export default withRouter(AppSignin);
